import { CrudModel } from "./_crud";

export class ServicePlanModel extends CrudModel {
	constructor() {
		super("admin/servicePlan");
	}
}

export default new ServicePlanModel();
